import { HttpResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { CaseUploadService } from '../case-upload.service';
import { ClientContractProfileService } from '../client-contract-profile.service';
import { ClientContractPackageService } from '../client-contract-package.service';
import { ComponentDataService } from '../component-data.service';
import { ComponentService } from '../component.service';
import { MatDialog } from '@angular/material/dialog';
import { SaveConfirmationComponent } from '../save-confirmation/save-confirmation.component';
import { PersonalDetailsDataService } from '../personal-details-data.service';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-candidate-component-data-entry',
  templateUrl: './candidate-component-data-entry.component.html',
  styleUrls: ['./candidate-component-data-entry.component.scss']
})
export class CandidateComponentDataEntryComponent implements OnInit {

  gdbValue:boolean = false;
  isDataSaved:boolean = false
  instructions: string
  addressComponent: boolean = false
  educationComponent: boolean = false
  employmentComponent: boolean = false
  identityComponent: boolean = false
  gapvfnComponent: boolean = false
  cvanalysisComponent: boolean = false
  uanComponent: boolean = false
  twentysixasComponent: boolean = false
  creditcheckComponent: boolean = false
  credittransComponent: boolean = false
  epfoComponent: boolean = false
  crconlineComponent: boolean = false
  socialmediaComponent: boolean = false
  globalmediasearchComponent: boolean = false
  facisl3Component: boolean = false
  ofacComponent: boolean = false
  drugtestComponent: boolean = false
  voterIdComponent: boolean = false
  panComponent: boolean = false
  passportComponent: boolean = false
  dlComponent: boolean = false
  adharComponent: boolean = false
  bankStatementComponent: boolean = false
  globaldatabaseComponent: boolean = false
  statusInDb: string
  inputqcComments: string
  componentDisplayName: string
  mandatoryField: boolean
  displayedCandidateDocName: any
  fileUploadRequired: boolean
  isFileUploaded = false;
  

  caseId: any
  case_id: any
  gapDataForTable: any
  profile: any
  package: any
  alacart:any
  check_id: any
  component_id : any
  components: any[] = []
  
  //tempComponents:any[]=[]
  navItems: any[] = []
  componentFields: any = []
  componentDataEntryForm = new FormGroup({
    fileName: new FormControl(''),
    componentFile: new FormControl('')
  })
  candidateDocuments: any[]
  candidateDocBlob: any
  showCandidateDocsDialog: boolean = false
  queryParamsSubscription: Subscription;
  previousParams:any;

  constructor(
    private caseUploadService: CaseUploadService,
    private clientContractProfileService: ClientContractProfileService,
    private clientContractPackageService: ClientContractPackageService,
    private activatedRoute: ActivatedRoute,
    private personalDetailsDataService: PersonalDetailsDataService,
    private componentService: ComponentService,
    private componentDataService: ComponentDataService,
    private snackBar: MatSnackBar,
    private dialog:MatDialog
  ) { }

  // ngOnInit(): void {
  //   this.getComponentDetails()
  //   this.getComponentFields()
  //   this.getTableDataForGap()   
  // }

  ngOnInit(): void {
    // console.log('Component initialized');

    // Subscribe to query parameter changes
    this.queryParamsSubscription = this.activatedRoute.queryParamMap.subscribe(params => {
      // console.log('params == ', params.get('component_id'));

      // Compare the current value of component_id with the previous one
      const currentParams = params.get('component_id');
      const paramsChanged = currentParams !== this.previousParams;
      // console.log('paramsChanged == ', paramsChanged);
      
      if (paramsChanged) {
        this.components = []
        this.getComponentDetails();
        this.getComponentFields();
        this.getTableDataForGap();   
      }
      
      // Update the previousParams to the current value
      this.previousParams = currentParams;
    });
  }

  // ngOnDestroy(): void {
  //   if (this.queryParamsSubscription) {
  //     this.queryParamsSubscription.unsubscribe();
  //   }
  // }

  async getComponentDetails() {
    await this.getCaseDetails()
    if (this.profile != null) {
      this.components = <any[]>await this.getProfileDetails()
    } else if (this.package != null) {
      this.components = <any[]>await this.getPackageDetails()
    }  else if (this.alacart != null) {
      this.components = <any[]>await this.getalacartDetails()
    }

    // console.log("Components contain ", this.components)
    //    this.components = <any[]>await this.addDisplayNameToComponents()
    await this.setComponentMenuItems()
    this.navItems.push({ displayName: 'Authorization', route: 'candidate/authorization', access_token: this.activatedRoute.snapshot.queryParamMap.get('access_token'), children: [] })
    await this.readComponentDetails()
    this.readCandidateDocs()
  }
  /*  addDisplayNameToComponents(){
      let promise = new Promise((resolve,reject)=>{
        this.tempComponents.forEach(item=>{
          this.componentService.findAComponentForCde(item.component,this.activatedRoute.snapshot.queryParamMap.get('access_token')).subscribe(
            response=>{
              let comp = ({
                componentName : item.componentName,
                displayName :response.displayName,
                component:item.component,
                maxChecks:item.maxChecks
              })
              this.components.push(comp)
            },
            error=>{
              this.showError("Error getting display Name")
            }
          )
          resolve(this.components)
        })
        console.log("Components before resoving is ",this.components)
  
      })
      return promise
    }*/
  getCaseDetails() {
    let promise = new Promise((resolve, reject) => {
      this.caseUploadService.getCdeCaseDetails(this.activatedRoute.snapshot.queryParamMap.get('access_token')).subscribe(
        response => {
          // console.log("Got reponse from cde case details")
          this.caseId = response.caseId
          this.case_id = response._id
          this.profile = response.profile
          this.package = response.package
          this.alacart = response.componentsToCheck
          // console.log("alacart",this.package),
          // console.log("alacart",this.alacart)
          resolve(true)
        },
        error => {
          this.showError("Error reading Case Details")
          resolve(false)
        })
    })
    return promise
  }
  getProfileDetails() {
    let promise = new Promise((resolve, reject) => {
      this.clientContractProfileService.getClientContractProfileDetails(this.profile + "?access_token=" + this.activatedRoute.snapshot.queryParamMap.get('access_token')).subscribe(
        response2 => {
          // console.log("Profile details are ", response2)
          this.navItems.push({
            displayName: 'Personal Details',
            route: `candidate/candidatepersonaldetails`,
            access_token: this.activatedRoute.snapshot.queryParamMap.get('access_token'),
            children: []
          })
          this.components = response2.clientContractProfileComponents
          this.components.forEach(item => {
            if (item.componentName == 'employment' || item.componentName == 'empbasic' || item.componentName == 'empadvance') {
              item.displayName = 'Employment'
              //              this.employmentComponent=true
            } else if (item.componentName == 'address' || item.componentName == 'addressonline' || item.componentName == 'addresstelephone' || item.componentName == 'addresscomprehensive') {
              item.displayName = 'Address'
              //              this.addressComponent=true
            } else if (item.componentName == 'educationcomprehensive' || item.componentName == 'educationadvanced' || item.componentName == 'education') {
              item.displayName = 'Education'
              //              this.educationComponent=true
            } else if (item.componentName == 'globaldatabase') {
              this.globaldatabaseComponent = true
              item.displayName = 'Global Database'
            } else if (item.componentName == 'reference' || item.componentName == 'refbasic') {
              item.displayName = 'Professional Reference'
              // Added By Navin On 15/2/24
            } else if (item.componentName == 'criminalrecord') {
              item.displayName = 'Criminal Record'
            } else if (item.componentName == 'courtrecord') {
              item.displayName = 'Court Record'
            } else if (item.componentName == 'identity') {
              item.displayName = 'Identity'
              //              this.identityComponent=true
            } else if (item.componentName == 'gapvfn') {
              item.displayName = 'GAP'
            } else if (item.componentName == 'drugtestfive' || item.componentName == 'drugtestsix' || item.componentName == 'drugtestseven' || item.componentName == 'drugtesteight' || item.componentName == 'drugtestnine' || item.componentName == 'drugtestten') {
              item.displayName = 'Drug Test'
            } else if (item.componentName == "cvanalysis") {
              item.displayName = 'CV Analysis'
            } else if (item.componentName == 'creditcheck') {
              item.displayName = 'Credit Check'
            } else if (item.componentName == 'uan') {
              item.displayName == 'UAN'
            }else if (item.componentName == 'twentysixas') {
              item.displayName = 'Form 26 AS'
            }else if (item.componentName == 'credittrans') {
              item.displayName == 'Credit Check - TransUnion'
            }else if (item.componentName == 'epfo') {
              item.displayName = 'EPFO Check'
            }else if (item.componentName == 'crconline') {
              item.displayName == 'Court Record (CRC ) - Law Firm (Online)'
            }else if (item.componentName == 'ofac') {
              item.displayName = 'OFAC Check'
            }else if (item.componentName == 'socialmedia') {
              item.displayName = 'Social Media Search'
            }else if(item.componentName == 'globalmediasearch'){
              item.displayName = 'Global Media Search'
            }else if(item.componentName == 'facisl3'){
              item.displayName = 'FACIS L3 Check'
            }
          })
          resolve(this.components)
        },
        error2 => {
          this.showError("Error reading profile details")
          resolve(null)
        }
      )
    })
    return promise
  }
  getPackageDetails() {
    let promise = new Promise((resolve, reject) => {
      this.clientContractPackageService.getClientContractPackageDetails(this.package + "?access_token=" + this.activatedRoute.snapshot.queryParamMap.get('access_token')).subscribe(
        response2 => {
          // console.log("Profile details are ", response2)
          this.navItems.push({
            displayName: 'Personal Details',
            route: `candidate/candidatepersonaldetails`,
            access_token: this.activatedRoute.snapshot.queryParamMap.get('access_token'),
            children: []
          })
          this.components = response2.clientContractPackageComponents
          this.components.forEach(item => {
            
            if (item.componentName == 'employment' || item.componentName == 'empbasic' || item.componentName == 'empadvance') {
              item.displayName = 'Employment'
              //              this.employmentComponent=true
            } else if (item.componentName == 'address' || item.componentName == 'addressonline' || item.componentName == 'addresstelephone' || item.componentName == 'addresscomprehensive') {
              item.displayName = 'Address'
              //              this.addressComponent=true
            } else if (item.componentName == 'educationcomprehensive' || item.componentName == 'educationadvanced' || item.componentName == 'education') {
              item.displayName = 'Education'
              //              this.educationComponent=true
            } else if (item.componentName == 'globaldatabase') {
              item.displayName = 'Global Database'
            } else if (item.componentName == 'reference' || item.componentName == 'refbasic') {
              item.displayName = 'Reference'
            } else if (item.componentName == 'criminalrecord') {
              item.displayName = 'Criminal Record'
            } else if (item.componentName == 'courtrecord') {
              item.displayName = 'Court Record'
            } else if (item.componentName == 'identity') {
              item.displayName = 'Identity'
              //              this.identityComponent=true
            } else if (item.componentName == 'gapvfn') {
              item.displayName = 'GAP'
            } else if (item.componentName == 'drugtestfive' || item.componentName == 'drugtestsix' || item.componentName == 'drugtestseven' || item.componentName == 'drugtesteight' || item.componentName == 'drugtestnine' || item.componentName == 'drugtestten') {
              item.displayName = 'Drug Test'
            } else if (item.componentName == "cvanalysis") {
              item.displayName = 'CV Analysis'
            } else if (item.componentName == 'creditcheck') {
              item.displayName = 'Credit Check'
            } else if (item.componentName == 'uan') {
              item.displayName = 'UAN'
            }else if (item.componentName == 'twentysixas') {
              item.displayName = 'Form 26 AS'
            }else if (item.componentName == 'credittrans') {
              item.displayName = 'Credit Check - TransUnion'
            }else if (item.componentName == 'epfo') {
              item.displayName = 'EPFO Check'
            }else if (item.componentName == 'crconline') {
              item.displayName = 'Court Record (CRC ) - Law Firm (Online)'
            }else if (item.componentName == 'ofac') {
              item.displayName = 'OFAC Check'
            }else if (item.componentName == 'socialmedia') {
              item.displayName = 'Social Media Search'
            }else if(item.componentName == 'globalmediasearch'){
              item.displayName = 'Global Media Search'
            }else if(item.componentName == 'facisl3'){
              item.displayName = 'FACIS L3 Check'
            }
            // else if(item.componentName = 'ofac'){
            //   item.displayName = 'OFAC Check'
            // }else if(item.componentName = 'socialmedia'){
            //   item.displayName = 'Social Media Search'
            // }
          })
          resolve(this.components)
        },
        error2 => {
          this.showError("Error reading profile details")
          resolve(null)
        }
      )
    })
    return promise
  }

    ///
    getalacartDetails() {
      let promise = new Promise((resolve, reject) => {
        this.caseUploadService.getCdeCaseDetails(this.activatedRoute.snapshot.queryParamMap.get('access_token')).subscribe(
        // this.clientContractPackageService.getClientContractComponentsDetails(this.alacart + "?access_token=" + this.activatedRoute.snapshot.queryParamMap.get('access_token')).subscribe(
          response2 => {
            // console.log("Profile details are ", response2)
            this.navItems.push({
              displayName: 'Personal Details',
              route: 'candidate/candidatepersonaldetails',
              access_token: this.activatedRoute.snapshot.queryParamMap.get('access_token'),
              children: []
            })
            this.components = response2.componentsToCheck
            // console.log("components to check",response2)
            // console.log("components to check",this.components)
            this.components.forEach(item => {
              if (item.componentName == 'employment' || item.componentName == 'empbasic' || item.componentName == 'empadvance') {
                item.displayName = 'Employment'
              } else if (item.componentName == 'address' || item.componentName == 'addressonline' || item.componentName == 'addresstelephone' || item.componentName == 'addresscomprehensive') {
                item.displayName = 'Address'
              } else if (item.componentName == 'educationcomprehensive' || item.componentName == 'educationadvanced' || item.componentName == 'education') {
                item.displayName = 'Education'
              } else if (item.componentName == 'globaldatabase') {
                item.displayName = 'Global Database'
              } else if (item.componentName == 'reference' || item.componentName == 'refbasic') {
                item.displayName = 'Reference'
              } else if (item.componentName == 'criminalrecord') {
                item.displayName = 'Criminal Record'
              } else if (item.componentName == 'courtrecord') {
                item.displayName = 'Court Record'
              } else if (item.componentName == 'identity') {
                item.displayName = 'Identity'
              } else if (item.componentName == 'gapvfn') {
                item.displayName = 'GAP'
              } else if (item.componentName == 'drugtestfive' || item.componentName == 'drugtestsix' || item.componentName == 'drugtestseven' || item.componentName == 'drugtesteight' || item.componentName == 'drugtestnine' || item.componentName == 'drugtestten') {
                item.displayName = 'Drug Test'
              } else if (item.componentName == 'cvanalysis') {
                item.displayName = 'CV Analysis'
              } else if (item.componentName == 'creditcheck') {
                item.displayName = 'Credit Check'
              }  else if (item.componentName == 'uan') {
                item.displayName = 'UAN'
              }else if (item.componentName == 'twentysixas') {
                item.displayName = 'Form 26 AS'
              }else if (item.componentName == 'credittrans') {
                item.displayName = 'Credit Check - TransUnion'
              }else if (item.componentName == 'epfo') {
                item.displayName = 'EPFO Check'
              }else if (item.componentName == 'crconline') {
                item.displayName = 'Court Record (CRC ) - Law Firm (Online)'
              }else if (item.componentName == 'ofac') {
                item.displayName = 'OFAC Check'
              }else if (item.componentName == 'socialmedia') {
                item.displayName = 'Social Media Search'
              }else if(item.componentName == 'globalmediasearch'){
                item.displayName = 'Global Media Search'
              }else if(item.componentName == 'facisl3'){
                item.displayName = 'FACIS L3 Check'
              }
              // else if(item.componentName = 'ofac'){
              //   item.displayName = 'OFAC Check'
              // }else if(item.componentName = 'socialmedia'){
              //   item.displayName = 'Social Media Search'
              // }
  
            })
            resolve(this.components)
          },
          error2 => {
            this.showError("Error reading profile details")
            resolve(null)
          }
        )
      })
      return promise
    }
  
    ////
  setComponentMenuItems() {
    let promise = new Promise((resolve, reject) => {
      this.components.forEach(item => {
        // console.log("Item in component details ", item)


        ////
        let childItems = []
        if (item.componentName == 'employment' || item.componentName == 'empbasic' || item.componentName == 'empadvance') {


          for (let i = 0; i < item.maxChecks; i++) {
            if (i == 0) {
              childItems.push({ displayName: "Current Employment" + "-" + (i) , component_id: item.component, componentName: item.componentName, component_serialNumber: (i + 1), children: [] })
              continue
            }
            childItems.push({ displayName: "Previous " + item.displayName + "-" + (i), component_id: item.component, componentName: item.componentName, component_serialNumber: (i + 1), children: [] })
          }
        } else {
          for (let i = 0; i < item.maxChecks; i++) {
            // childItems.push({ displayName: item.displayName + "-" + (i + 1), route: `candidate/candidatecomponentdataentry`, component_id: item.component, access_token: this.activatedRoute.snapshot.queryParamMap.get('access_token'), componentName: item.componentName, component_serialNumber: (i + 1), children: [] })
            // childItems.push({ displayName: item.displayName + "-" + (i + 1), route: `candidate/candidatecomponentdataentry`, component_id: item.component, componentName: item.componentName, component_serialNumber: (i + 1), children: [] })
            childItems.push({ displayName: item.displayName + "-" + (i + 1), route: `candidate/candidatecomponentdataentry`, component_id: item.component, access_token: this.activatedRoute.snapshot.queryParamMap.get('access_token'), componentName: item.componentName, component_serialNumber: (i + 1), children: [] })
          }
        }


        // console.log("ChildItems: ", childItems)
        this.navItems.push({ displayName: item.displayName, children: childItems, disable:false })
        resolve(true)
        ////
        // 20Dec2023
        // let childItems = []
        // if (item.componentName == 'employment' || item.componentName == 'empbasic' || item.componentName == 'empadvance') {


        //   for (let i = 0; i < item.maxChecks; i++) {
        //       childItems.push({ displayName: "Current Employment" + item.displayName + "-" +(i+1),component_id:item.component,componentName:item.componentName,component_serialNumber:(i+1),children:[] })

        //   }
        // } else {
        //   for (let i = 0; i < item.maxChecks; i++) {

        //     childItems.push({displayName:item.displayName + "-" +(i+1),component_id:item.component,componentName:item.componentName,component_serialNumber:(i+1),children:[]})
        //   }
        // }


        // console.log("ChildItems: ", childItems)
        // this.navItems.push({ displayName: item.displayName, children: childItems })
        // resolve(true)
         // 20Dec2023
      })

    })
    return promise
  }


  async getComponentFields() {
    // console.log("Component in query map is ", this.activatedRoute.snapshot.queryParamMap.get('component._id'))
    this.componentService.findAComponentForCde(this.activatedRoute.snapshot.queryParamMap.get('component_id') , this.activatedRoute.snapshot.queryParamMap.get('access_token'), this.activatedRoute.snapshot.queryParamMap.get('component_serialNumber')).subscribe(
      response => {
        // console.log("Response: ", response)
        this.fileUploadRequired = response.fileUploadRequired
        // console.log("File upload:", this.fileUploadRequired)
        this.componentFields = response.componentFields;
        this.mandatoryField = this.componentFields.mandatory === "MANDATORY" ? true : false
        // console.log("Mandatory: ", this.mandatoryField)
        this.componentDisplayName = response.displayName
        if (response.name == 'employment' || response.name == 'empbasic' || response.name == 'empadvance') {
          //          this.componentDisplayName = 'Employment'
          this.employmentComponent = true
          this.addressComponent = false
          this.educationComponent = false
          this.identityComponent = false
          this.drugtestComponent = false
          this.gapvfnComponent = false
          this.globaldatabaseComponent = false
          this.cvanalysisComponent= false
          this.creditcheckComponent=false
          this.uanComponent=false 
          this.twentysixasComponent=false
          this.credittransComponent=false
          this.epfoComponent=false
          this.crconlineComponent=false
          this.socialmediaComponent=false
          this.globalmediasearchComponent=false
 this.facisl3Component=false          
          this.ofacComponent=false
        } else if (response.name == 'address' || response.name == 'addressonline' || response.name == 'addresstelephone' || response.name == 'addresscomprehensive') {
          //          this.componentDisplayName = 'Address'
          this.addressComponent = true
          this.educationComponent = false
          this.employmentComponent = false
          this.identityComponent = false
          this.drugtestComponent = false
          this.gapvfnComponent = false
          this.globaldatabaseComponent = false
          this.cvanalysisComponent= false
          this.creditcheckComponent=false
          this.uanComponent=false 
          this.twentysixasComponent=false
          this.credittransComponent=false
          this.epfoComponent=false
          this.crconlineComponent=false
          this.socialmediaComponent=false
          this.globalmediasearchComponent=false
 this.facisl3Component=false     
      this.ofacComponent=false
        } else if (response.name == 'educationcomprehensive' || response.name == 'educationadvanced' || response.name == 'education') {
          //          response.displayName = 'Education'
          this.educationComponent = true
          this.employmentComponent = false
          this.addressComponent = false
          this.identityComponent = false
          this.drugtestComponent = false
          this.gapvfnComponent = false
          this.globaldatabaseComponent = false
          this.cvanalysisComponent= false
          this.creditcheckComponent=false
          this.uanComponent=false 
          this.twentysixasComponent=false
          this.credittransComponent=false
          this.crconlineComponent=false
                    this.socialmediaComponent=false
          this.globalmediasearchComponent=false
 this.facisl3Component=false  
         this.ofacComponent=false
          this.epfoComponent=false
        } else if (response.name == 'globaldatabase') {
          this.globaldatabaseComponent = true
          this.identityComponent = false
          this.educationComponent = false
          this.employmentComponent = false
          this.addressComponent = false
          this.drugtestComponent = false
          this.gapvfnComponent = false
          this.cvanalysisComponent= false
          this.creditcheckComponent=false
          this.uanComponent=false 
          this.twentysixasComponent=false
          this.credittransComponent=false
          this.epfoComponent=false
          this.crconlineComponent=false
                    this.socialmediaComponent=false
          this.globalmediasearchComponent=false

 this.facisl3Component=false    
       this.ofacComponent=false
          //          response.displayName = 'Global Database'globaldatabaseComponent
        } else if (response.name == 'reference' || response.name == 'refbasic') {
          //          response.displayName = 'Reference'
        } else if (response.name == 'criminalrecord') {
          //          response.displayName = 'Criminal Record'
        } else if (response.name == 'courtrecord') {
          //          response.displayName = 'Court Record'
        } else if (response.name == 'identity') {
          //response.displayName = 'Identity'
          this.identityComponent = true
          this.educationComponent = false
          this.employmentComponent = false
          this.addressComponent = false
          this.drugtestComponent = false
          this.gapvfnComponent = false
          this.globaldatabaseComponent = false
          this.cvanalysisComponent= false
          this.creditcheckComponent=false
          this.uanComponent=false 
          this.twentysixasComponent=false
          this.credittransComponent=false
          this.epfoComponent=false
          this.crconlineComponent=false
                    this.socialmediaComponent=false
          this.globalmediasearchComponent=false
 this.facisl3Component=false       
    this.ofacComponent=false
        } else if (response.name == 'gapvfn') {
          this.gapvfnComponent = true
          this.identityComponent = false
          this.educationComponent = false
          this.employmentComponent = false
          this.addressComponent = false
          this.globaldatabaseComponent = false
          this.drugtestComponent = false
          this.cvanalysisComponent= false
          this.creditcheckComponent=false
          this.uanComponent=false 
          this.twentysixasComponent=false
          this.credittransComponent=false
          this.epfoComponent=false
          this.crconlineComponent=false
                    this.socialmediaComponent=false
          this.globalmediasearchComponent=false
 this.facisl3Component=false     
      this.ofacComponent=false
        } else if (response.name == 'drugtestfive' || response.name == 'drugtestsix' || response.name == 'drugtestseven' || response.name == 'drugtesteight' || response.name == 'drugtestnine' || response.name == 'drugtestten') {
          this.drugtestComponent = true
          this.gapvfnComponent = false
          this.identityComponent = false
          this.educationComponent = false
          this.employmentComponent = false
          this.addressComponent = false
          this.globaldatabaseComponent = false
          this.cvanalysisComponent= false
          this.creditcheckComponent=false
          this.uanComponent=false 
          this.twentysixasComponent=false
          this.credittransComponent=false
          this.epfoComponent=false
          this.crconlineComponent=false
                    this.socialmediaComponent=false
          this.globalmediasearchComponent=false
 this.facisl3Component=false       
    this.ofacComponent=false
        }else if (response.name == 'cvanalysis') {
          this.cvanalysisComponent= true
          this.gapvfnComponent = false
          this.identityComponent = false
          this.educationComponent = false
          this.employmentComponent = false
          this.addressComponent = false
          this.globaldatabaseComponent = false
          this.drugtestComponent = false
          this.creditcheckComponent=false
          this.uanComponent=false 
          this.twentysixasComponent=false
          this.credittransComponent=false
          this.epfoComponent=false
          this.crconlineComponent=false
                    this.socialmediaComponent=false
          this.globalmediasearchComponent=false
 this.facisl3Component=false   
        this.ofacComponent=false
        }else if (response.name == 'creditcheck') {
          this.creditcheckComponent=true
          this.cvanalysisComponent= false
          this.gapvfnComponent = false
          this.identityComponent = false
          this.educationComponent = false
          this.employmentComponent = false
          this.addressComponent = false
          this.globaldatabaseComponent = false
          this.drugtestComponent = false
          this.uanComponent=false 
          this.twentysixasComponent=false
          this.credittransComponent=false
          this.epfoComponent=false
          this.crconlineComponent=false
                    this.socialmediaComponent=false
          this.globalmediasearchComponent=false
 this.facisl3Component=false   
        this.ofacComponent=false
        }else if (response.name == 'uan') {
          this.uanComponent=true
          this.twentysixasComponent=false
          this.creditcheckComponent=false
          this.cvanalysisComponent= false
          this.gapvfnComponent = false
          this.identityComponent = false
          this.educationComponent = false
          this.employmentComponent = false
          this.addressComponent = false
          this.globaldatabaseComponent = false
          this.drugtestComponent = false 
          this.credittransComponent=false
          this.epfoComponent=false
          this.crconlineComponent=false
                    this.socialmediaComponent=false
          this.globalmediasearchComponent=false
 this.facisl3Component=false      
     this.ofacComponent=false
        }else if (response.name == 'twentysixas') {
          this.twentysixasComponent=true
          this.uanComponent=false
          this.creditcheckComponent=false
          this.cvanalysisComponent= false
          this.gapvfnComponent = false
          this.identityComponent = false
          this.educationComponent = false
          this.employmentComponent = false
          this.addressComponent = false
          this.globaldatabaseComponent = false
          this.drugtestComponent = false 
          this.credittransComponent=false
          this.epfoComponent=false
          this.crconlineComponent=false
                    this.socialmediaComponent=false
          this.globalmediasearchComponent=false
 this.facisl3Component=false    
       this.ofacComponent=false
        }else if (response.name == 'credittrans') {
          this.credittransComponent=true
          this.twentysixasComponent=false
          this.uanComponent=false
          this.creditcheckComponent=false
          this.cvanalysisComponent= false
          this.gapvfnComponent = false
          this.identityComponent = false
          this.educationComponent = false
          this.employmentComponent = false
          this.addressComponent = false
          this.globaldatabaseComponent = false
          this.drugtestComponent = false 
          this.epfoComponent=false
          this.crconlineComponent=false
                    this.socialmediaComponent=false
          this.globalmediasearchComponent=false
 this.facisl3Component=false     
      this.ofacComponent=false
        }else if (response.name == 'epfo') {
          this.epfoComponent=true
          this.credittransComponent=false
          this.twentysixasComponent=false
          this.uanComponent=false
          this.creditcheckComponent=false
          this.cvanalysisComponent= false
          this.gapvfnComponent = false
          this.identityComponent = false
          this.educationComponent = false
          this.employmentComponent = false
          this.addressComponent = false
          this.globaldatabaseComponent = false
          this.drugtestComponent = false 
          this.crconlineComponent=false
                    this.socialmediaComponent=false
          this.globalmediasearchComponent=false
 this.facisl3Component=false     
      this.ofacComponent=false
        }else if (response.name == 'crconline') {
          this.crconlineComponent=true
          this.epfoComponent=false
          this.credittransComponent=false
          this.twentysixasComponent=false
          this.uanComponent=false
          this.creditcheckComponent=false
          this.cvanalysisComponent= false
          this.gapvfnComponent = false
          this.identityComponent = false
          this.educationComponent = false
          this.employmentComponent = false
          this.addressComponent = false
          this.globaldatabaseComponent = false
          this.drugtestComponent = false
                    this.socialmediaComponent=false
          this.globalmediasearchComponent=false 
          this.ofacComponent=false
        }else if (response.name == 'socialmedia') {
          this.socialmediaComponent=true
          this.globalmediasearchComponent=false
 this.facisl3Component=false     
      this.crconlineComponent=false
          this.epfoComponent=false
          this.credittransComponent=false
          this.twentysixasComponent=false
          this.uanComponent=false
          this.creditcheckComponent=false
          this.cvanalysisComponent= false
          this.gapvfnComponent = false
          this.identityComponent = false
          this.educationComponent = false
          this.employmentComponent = false
          this.addressComponent = false
          this.globaldatabaseComponent = false
          this.drugtestComponent = false
          this.ofacComponent=false
        }else if (response.name == 'ofac') {
          this.ofacComponent=true
          this.socialmediaComponent=false
          this.globalmediasearchComponent=false
 this.facisl3Component=false   
        this.crconlineComponent=false
          this.epfoComponent=false
          this.credittransComponent=false
          this.twentysixasComponent=false
          this.uanComponent=false
          this.creditcheckComponent=false
          this.cvanalysisComponent= false
          this.gapvfnComponent = false
          this.identityComponent = false
          this.educationComponent = false
          this.employmentComponent = false
          this.addressComponent = false
          this.globaldatabaseComponent = false
          this.drugtestComponent = false
          
        }else if (response.name == 'globalmediasearch') {
          this.ofacComponent=false
           this.socialmediaComponent=false
           this.facisl3Component=false   
          this.globalmediasearchComponent=true
          this.crconlineComponent=false
          this.epfoComponent=false
          this.credittransComponent=false
          this.twentysixasComponent=false
          this.uanComponent=false
          this.creditcheckComponent=false
          this.cvanalysisComponent= false
          this.gapvfnComponent = false
          this.identityComponent = false
          this.educationComponent = false
          this.employmentComponent = false
          this.addressComponent = false
          this.globaldatabaseComponent = false
          this.drugtestComponent = false
          
        }else if (response.name == 'facisl3') {
          this.facisl3Component=true   

          this.ofacComponent=false
           this.socialmediaComponent=false
          this.globalmediasearchComponent=false
          this.crconlineComponent=false
          this.epfoComponent=false
          this.credittransComponent=false
          this.twentysixasComponent=false
          this.uanComponent=false
          this.creditcheckComponent=false
          this.cvanalysisComponent= false
          this.gapvfnComponent = false
          this.identityComponent = false
          this.educationComponent = false
          this.employmentComponent = false
          this.addressComponent = false
          this.globaldatabaseComponent = false
          this.drugtestComponent = false
          
        }
        
        this.addFormControls();
      },
      error => {
        this.showError("Error Configuring Personal Details");
      }
    )
  }
  addFormControls() {
    this.componentFields.forEach(item => {
      this.componentDataEntryForm.addControl(item.name, new FormControl(''));
      if (item.mandatory === "MANDATORY") {
        this.componentDataEntryForm.get(item.name).setValidators(Validators.required);
      }
    })

  }
  getFieldSize(componentField: any) {
    return componentField.size;
  }
  getValues(name) {
    for (let field of this.componentFields) {
      if (field.name === name) {
        let values = field.values;
        if (values !== "") {
          return values.split(",");
        }
      }
    }
    return null;
  }
  readComponentDetails() {
    let promise = new Promise((resolve, reject) => {
      for (let i = 0; i < this.components.length; i++) {
        let item = this.components[i]
        // console.log("shoaib",)
        if (this.activatedRoute.snapshot.queryParamMap.get('component_id') == item.component) {
          this.instructions = item.details
          break
        }
      }
      if (this.activatedRoute.snapshot.queryParamMap.get('componentName') === 'globaldatabase') {
        this.personalDetailsDataService.readForCde(this.case_id, this.activatedRoute.snapshot.queryParamMap.get('access_token')).subscribe(
          response => {
            if (response) {
              // console.log('response for global ==', response);
              // this.personalDetails = response._id;
              // console.log('item', this.componentFields);
              this.gdbValue = true;
              this.componentFields.forEach(item => {
               
                if (item.type != 'DATE') {
                  if (item.name === "searchname") {
                    this.componentDataEntryForm.get(item.name)?.setValue(response.candidatename);
                  }
                   else {
                    this.componentDataEntryForm.get(item.name)?.setValue(response[item.name]);
                    
                  }
                  
                } else {

                  //              console.log('this is the date type ',response[item.name]);
                  //              this.personalDetailsDataEntryform.get(item.name).setValue(this.datePipe.transform(response[item.name],'yyyy-MM-dd'));
                  let dateValue = new Date(response.dateofbirth);
                  let dd = dateValue.getDate();
                  let mm = dateValue.getMonth() + 1;
                  let yyyy = dateValue.getFullYear().toString();
                  let stringdd = '';
                  let stringmm = ''
    
                  if (dd < 10) {
                    stringdd = '0' + dd;
                  } else {
                    stringdd = dd.toString();
                  }
                  if (mm < 10) {
                    stringmm = '0' + mm;
                  } else {
                    stringmm = mm.toString();
                  }
                  //   
                            //  console.log('converted value is ',yyyy+mm+stringdd)
                            //  if (item.name === "dob") {
                            //   this.componentDataEntryForm.get(item.name)?.setValue(response.dateofbirth);
                            // }
                  this.componentDataEntryForm.get(item.name).setValue(yyyy + '-' + stringmm + '-' + stringdd);
                }
              })
            }
    
          },
          error => {
            this.showError(error.error.message);
          }
        )
      }
      this.componentDataService.findOneForCde(this.activatedRoute.snapshot.queryParamMap.get('componentName'), this.case_id, this.activatedRoute.snapshot.queryParamMap.get('component_serialNumber')).subscribe(
        response => {
          // console.log("Response for the check......", response);

          if (response) {
            // console.log("I rannnnnnnnnnnnnn")
            this.check_id = response._id;
            // console.log("CheckId: ", this.check_id)
            // console.log("Response: ", response)

            this.case_id = response.case
            this.componentFields.forEach(item => {
              if (item.type != 'DATE') {
                this.componentDataEntryForm.get(item.name).setValue(response[item.name]);
              } else {
                //              console.log('this is the date type ',response[item.name]);
                //              this.personalDetailsDataEntryform.get(item.name).setValue(this.datePipe.transform(response[item.name],'yyyy-MM-dd'));
                let dateValue = new Date(response[item.name]);
                let dd = dateValue.getDate();
                let mm = dateValue.getMonth() + 1;
                let yyyy = dateValue.getFullYear().toString();
                let stringdd = '';
                let stringmm = ''

                if (dd < 10) {
                  stringdd = '0' + dd;
                } else {
                  stringdd = dd.toString();
                }
                if (mm < 10) {
                  stringmm = '0' + mm;
                } else {
                  stringmm = mm.toString();
                }
                //              console.log('converted value is ',yyyy+mm+stringdd)
                this.componentDataEntryForm.get(item.name).setValue(yyyy + '-' + stringmm + '-' + stringdd);
              }
            })
            //          this.personalDetailsDataEntryForm.get('status').setValue(response.status);
            //          this.personalDetailsDataEntryForm.get('insufficiencyComments').setValue(response.infsufficiencyComments);
            //          console.log('input qc status is ',response.inputqcStatus);
            //          console.log('input qc comments are ',response.inputqcComments);
            //          this.personalDetailsInputqcStatus = response.status;
            //          this.personalDetailsInputqcComments =response.inputqcComments;
            //          console.log("personal details  inputqcstatus is ",this.personalDetailsInputqcStatus);
            if (response.status != null && response.status == 'CDE-REJECTED') {
              this.inputqcComments = response.inputqcComments
              this.statusInDb = response.status
            }
          }
          /*          if(response.status != null && response.status =='CDE-REJECTED'){
                      this.inputqcComments = response.inputqcComments
                      this.statusInDb = response.status
                    }*/
          resolve(true)
        },
        error => {
          this.showError(error.error.message);
          resolve(false)
        }
      )
    })
    return promise
  }
  readCandidateDocs() {
    this.candidateDocuments = []
    this.componentDataService.readFileNamesForCde(this.activatedRoute.snapshot.queryParamMap.get('componentName'), this.caseId, this.check_id).subscribe(
      response => {
        this.candidateDocuments = response;
      },
      error => {
        console.log(error);
      }
    )
  }

  saveConfirmation(){
    const confirmDialog = this.dialog.open(SaveConfirmationComponent,{
      width:'400px',data:{message:`Are you sure that you want to submit this form `}
    });
    confirmDialog.afterClosed().subscribe(result=>{
      if(result.event=='confirmed'){
        this.saveButtonClicked();
      }
    })  
  }




  saveButtonClicked() {
    
    if (this.check_id == null) {
      let componentData = this.componentDataEntryForm.getRawValue()
      console.log('save click if block this.check_id === ', this.check_id);
      
      // componentData.status = "CDE-COMPLETED"
      // componentData.case = this.case_id
      // componentData.component = this.activatedRoute.snapshot.queryParamMap.get('component_id')
      // componentData.serialNumber = this.activatedRoute.snapshot.queryParamMap.get('component_serialNumber')
      // this.componentDataService.findOneForCde(this.activatedRoute.snapshot.queryParamMap.get('componentName'), this.case_id, this.activatedRoute.snapshot.queryParamMap.get('component_serialNumber')).subscribe(
      //   responseFromRead => {
      //     if (responseFromRead == null) {
      //       this.componentDataService.createForCde(this.activatedRoute.snapshot.queryParamMap.get('componentName'), componentData).subscribe(
      //         response => {
      //           this.check_id = response._id
      //           this.showMessage("Data Saved")
      //         },
      //         error => {
      //           this.showError("Error creating the check")
      //         }
      //       )
      //     } else {
      //       this.showError("Details Already Saved")
      //     }
      //   },
      //   error => {
      //     this.showError("Error reading the Details")
      //   }
      // )
    } else {
      let componentData = this.componentDataEntryForm.getRawValue()
      console.log('componentData   === ', componentData);
      // this.navItems.forEach((item,index) => {
      //   if (this.activatedRoute.snapshot.queryParamMap.get('component_id') === item.children[0]?.component_id) {
      //     item.disable = false;
      //     if (index < this.navItems.length - 1) {
      //       this.navItems[index + 1].disable = false;
      //   }
      //   }
      // })
      // componentData.status = "CDE-COMPLETED"
      // componentData.case = this.case_id
      // componentData.case_id = this.case_id
      // componentData._id = this.check_id
      // componentData.component = this.activatedRoute.snapshot.queryParamMap.get('component_id')
      // componentData.serialNumber = this.activatedRoute.snapshot.queryParamMap.get('component_serialNumber')
      // this.componentDataService.updateForCde(this.activatedRoute.snapshot.queryParamMap.get('componentName'), componentData).subscribe(
      //   response => {
      //     this.check_id = response._id
      //     this.showMessage("Data Saved")
      //   },
      //   error => {
      //     this.showError("Error Updating the check")
      //   }
      // )
    }
    // this.isDataSaved = true

  }
  downloadCandidateDoc(fileName) {
    let componentDetails = ({

    })
    componentDetails["caseId"] = this.caseId;
    componentDetails["_id"] = this.check_id;
    this.componentDataService.downloadFileForCde(this.activatedRoute.snapshot.queryParamMap.get('componentName'), componentDetails, fileName).subscribe(
      (response: HttpResponse<Blob>) => {
        // console.log("dasdedesd",response.body);
        
        this.candidateDocBlob = response.body;
        this.showCandidateDocsDialog = true;
      },
      error => {
        this.showError(error.error.message);
      }
    )
  }
  onFileSelected(event:any){
    const files = event.target.files;
    if(files.length > 0){
      const fileName = files[0].name;
      this.componentDataEntryForm.get('fileName').setValue(fileName);
    }
  }
  uploadFile() {
    if (this.check_id == null) {
      console.log("if.............................")
      let componentData = this.componentDataEntryForm.getRawValue()
      componentData.status = "CDE-COMPLETED"
      componentData.case = this.case_id
      componentData.case_id = this.case_id;
      componentData.caseId = this.caseId;
      componentData.case = this.case_id;
      componentData._id = this.check_id
      componentData.component = this.activatedRoute.snapshot.queryParamMap.get('component_id')
      componentData.serialNumber = this.activatedRoute.snapshot.queryParamMap.get('component_serialNumber')
      console.log("componentData :",componentData)
      this.componentDataService.createForCde(this.activatedRoute.snapshot.queryParamMap.get('componentName'), componentData).subscribe(
        response => {
          console.log("response :",response)
          this.check_id = response._id
          let componentData = this.componentDataEntryForm.getRawValue();
          componentData.case_id = this.case_id;
          componentData.caseId = this.caseId;
          componentData.case = this.case_id;
          componentData._id = this.check_id
          this.componentDataService.uploadFileForCde(this.activatedRoute.snapshot.queryParamMap.get('componentName'), componentData, this.componentDataEntryForm.get('componentFile').value.files[0]).subscribe(
            response => {
              this.showMessage("File Uploaded");
              this.readCandidateDocs()
            },
            error => {
              this.showError("Error uploading the file");
            }
          )
        },
        error => {
          console.log("Create error ", error)
          this.showError("Error creating the check")
        }
      )
    } else {
      console.log("else.............................")
      let componentData = this.componentDataEntryForm.getRawValue()
      componentData.status = "CDE-COMPLETED"
      componentData.case = this.case_id
      componentData.case_id = this.case_id
      componentData._id = this.check_id
      componentData.case_id = this.case_id;
      componentData.caseId = this.caseId;
      componentData.case = this.case_id;
      componentData._id = this.check_id
      componentData.component = this.activatedRoute.snapshot.queryParamMap.get('component_id')
      componentData.serialNumber = this.activatedRoute.snapshot.queryParamMap.get('component_serialNumber')
      console.log("@@@@@@@@@@@@@@@@@@@@@",componentData);
      
      this.componentDataService.updateForCde(this.activatedRoute.snapshot.queryParamMap.get('componentName'), componentData).subscribe(
        response => {
          //          this.check_id = response._id
          let componentData = this.componentDataEntryForm.getRawValue();
          componentData.case_id = this.case_id;
          componentData.caseId = this.caseId;
          componentData.case = this.case_id;
          componentData._id = this.check_id
          this.componentDataService.uploadFileForCde(this.activatedRoute.snapshot.queryParamMap.get('componentName'), componentData, this.componentDataEntryForm.get('componentFile').value.files[0]).subscribe(
            response => {
              this.showMessage("File Uploaded");
              this.readCandidateDocs()
            },
            error => {
              this.showError("Error uploading the file");
            }
          )
        },
        error => {
          console.log("update error ", error)
          this.showError("Error updating the check")
        }
      )
    }
    const formData = new FormData();
    const files = this.componentDataEntryForm.get('componentFile').value.files;
    if (files.length > 0) {
        const file = files[0];
        const fileName = encodeURIComponent(file.name); 
        formData.append('file', file, fileName);
    }

    this.isFileUploaded = true;
    }
  getTableDataForGap() {
    // console.log("Component in query map is ", this.activatedRoute.snapshot.queryParamMap.get('component_id'))
    this.componentService.findAComponentForCde(this.activatedRoute.snapshot.queryParamMap.get('component_id'), this.activatedRoute.snapshot.queryParamMap.get('access_token'), this.activatedRoute.snapshot.queryParamMap.get('component_serialNumber')).subscribe(
      response => {
        if (response.name === "gapvfn") {
          this.componentService.getGapDataForTable(this.case_id).subscribe(
            gapResponse => {
              this.gapDataForTable = gapResponse
            },
            gapError => {
              this.gapDataForTable = []
            }
          )
        }
      }
    )
  }
  deleteCandidateDoc(fileName) {
    let componentDetails = ({

    })
    componentDetails["caseId"] = this.caseId;
    componentDetails["_id"] = this.check_id;
    this.componentDataService.deleteFileForCde(this.activatedRoute.snapshot.queryParamMap.get('componentName'), componentDetails, fileName).subscribe(
      response => {
        this.showMessage("File Deleted")
      },
      error => {
        this.showError("Error Deleting the file")
      }
    )
  }
  deleteButtonClicked() {
    this.componentDataService.deleteForCde(this.activatedRoute.snapshot.queryParamMap.get("componentName"), this.case_id, this.check_id).subscribe(
      response => {
        this.componentDataService.deleteAllFilesForCde(this.activatedRoute.snapshot.queryParamMap.get('componentName'), this.caseId, this.check_id).subscribe(
          response => {
            this.showMessage("Deleted the Details")
            this.readCandidateDocs()
          },
          error => {
            this.showError("Error Deleting files")
          }
        )

      },
      error => {
        this.showError("Error deleting the Details")
      }
    )
  }
  closeCandidateDocsDialog() {
    this.showCandidateDocsDialog = false
  }
  showError(msg) {
    this.snackBar.open(msg, 'Error', { duration: 4000, horizontalPosition: 'end', verticalPosition: 'top' })
  }
  showMessage(msg) {
    this.snackBar.open(msg, 'Info', { duration: 4000, horizontalPosition: 'end', verticalPosition: 'top' })
  }

}
